import { jsx as e } from "react/jsx-runtime";
function t(l) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "15.238095238095237",
      height: "16",
      viewBox: "0 0 20 21",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.571349 20.5938C0.415649 20.6309 0.251629 20.5849 0.137909 20.4724C0.0239292 20.3598 -0.0238008 20.1967 0.0113392 20.0404L1.0385 15.4004L5.10503 19.4875L0.571349 20.5938ZM6.20639 18.3818L2.14017 14.2939L12.4363 3.94508L16.5051 8.03305L6.20639 18.3818ZM19.592 4.93402L17.5649 6.97089L13.4961 2.88292L15.2338 1.13669C15.5704 0.798368 16.0281 0.608398 16.5052 0.608398C16.9826 0.608398 17.4401 0.798368 17.7769 1.13669L19.592 2.95979C19.8532 3.22178 20 3.57693 20 3.94691C20 4.3172 19.8532 4.67202 19.592 4.93403V4.93402Z"
        }
      )
    }
  );
}
export {
  t as SmallPenIcon
};
